import { createAsyncThunk } from '@reduxjs/toolkit';
import { BoardMembersFormViewModel } from '../../types/BoardMembersFormViewModel';
import { thunkExecuteAndReturnResultOrShowError } from '../../services/base.service';
import {
  getBoardMembersFormViewModel,
  getBoardMembersListItems,
  getBoardMembersItemById,
  getStateOptions,
  getBoardMembersSchoolYears
} from '../../services/boardMembers.service';
import { BoardMembersListItemModel } from '../../types/BoardMembersListItemModel';
import { BoardMembersItemModel } from '../../types/BoardMembersItemModel';
import { getCurrentUserAccess } from '../../services/base.service'
import { SelectOption } from '../../types/SelectOption';

export const fetchBoardMembersListItems = createAsyncThunk(
  'input/fetchBoardMembersListItems',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      BoardMembersListItemModel[]
    >(
      thunkAPI,
      getBoardMembersListItems( { signal: thunkAPI.signal })
    );
  }
);

export const fetchBoardMemberById = createAsyncThunk(
  'input/fetchBoardMemberById',
    async (boardMemberId: string, thunkAPI) => {
    const leaId = await getCurrentUserAccess()?.currentDistrict?.districtId;
      return await thunkExecuteAndReturnResultOrShowError<BoardMembersItemModel>(
        thunkAPI,
        getBoardMembersItemById(boardMemberId, leaId, { signal: thunkAPI.signal })
      );
    }
 );

export const fetchBoardMembersFormViewModel = createAsyncThunk(
  'input/fetchBoardMembersFormViewModel',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<BoardMembersFormViewModel>(
      thunkAPI,
      getBoardMembersFormViewModel({ signal: thunkAPI.signal })
    );
  }
);

export const fetchStateOptions = createAsyncThunk(
  'input/fetchStateOptions',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<SelectOption[]>(
      thunkAPI,
      getStateOptions({ signal: thunkAPI.signal })
    );
  }
);

export const fetchBoardMembersSchoolYears = createAsyncThunk(
  'input/fetchBoardMembersSchoolYears',
  async (_, thunkAPI) => {
    return await thunkExecuteAndReturnResultOrShowError<
      SelectOption[]
    >(
      thunkAPI,
      getBoardMembersSchoolYears( { signal: thunkAPI.signal })
    );
  }
);